export default __webpack_public_path__ + "static/6664-885ce1612eb82e33adfd07d123d71340.jpg";